document.addEventListener('DOMContentLoaded', () => {
	initBetterPricePopupScrollLock();
});

function initBetterPricePopupScrollLock() {
	const updateBodyOverflow = () => {
		const hasPopup = Boolean(
			document.querySelector('.betterPriceWrapper')
		);

		document.body.classList.toggle(
			'better-price-popup-open',
			hasPopup
		);
	};

	const observer = new MutationObserver(updateBodyOverflow);

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	updateBodyOverflow();
}
